import type { ReactNode } from 'react'
import SalePanelCollapse from './SalePanelCollapse'
import type { SalePanelState } from './useSalePanels'
import { PanelIcon } from './styled-components'

interface SalePanelProps {
  panel: SalePanelState | null
  icon: ReactNode
  children: ReactNode
}

const SalePanel = ({ panel, icon, children }: SalePanelProps) => {
  if (!panel) return null

  return (
    <SalePanelCollapse
      id={panel.id}
      last={panel.last}
      open={panel.open}
      onToggle={panel.onToggle}
      title={
        <>
          <PanelIcon>{icon}</PanelIcon>
          {panel.label}
        </>
      }
    >
      {children}
    </SalePanelCollapse>
  )
}

export default SalePanel
